function helperStringLowerCase (str) {
  return str.toLowerCase()
}

module.exports = helperStringLowerCase



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/string/helperStringLowerCase.js
// module id = 625
// module chunks = 106